Service = App.loadClass 'core::Angular/Service'

class exports.ProfileService extends Service
    constructor: (@http) ->
        undefined

    getProfileData: () ->
        return @http.post 'backend/grower/profile/get'
